// extracted by LIB_CSS_EXTRACT_LOADER
import "./drawer_module.css"
export default {"backdrop":"backdrop-xm7ujY","popup":"popup-JqC7fO","handle":"handle-b1XWYZ","content":"content-Ep0a1b","header":"header-U4Xp3k","footer":"footer-HXJdCn","title":"title-EQEXsX","description":"description-D_oeYH"};